import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./CorrosionDosing.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";

import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




      // ================= MIXING IMPELLER COMPONENT =================
function MixingTankImpeller({
  x = 200,
  y = 200,
  size = 100,
  bladeCount = 6,
  speed = 2,
  isP3101On = false
}) {
  const [angle, setAngle] = useState(0);

  useEffect(() => {
    if (!isP3101On) return;

    const interval = setInterval(() => {
      setAngle(prev => (prev + speed) % 360);
    }, 30);

    return () => clearInterval(interval);
  }, [isP3101On, speed]);

  const blades = [];

  for (let i = 0; i < bladeCount; i++) {
    const rotation = (360 / bladeCount) * i;

    blades.push(
      <rect
        key={i}
        x={-5}
        y={-size / 2}
        width={10}
        height={size / 2}
        fill="#555"
        rx="2"
        transform={`rotate(${rotation})`}
      />
    );
  }

  return (
    <g transform={`translate(${x}, ${y}) rotate(${angle})`}>
      <circle r={8} fill="#222" />
      {blades}
    </g>
  );
}
 

 

function CorrosionDosing() {

  useEffect(() => {

  trackPageVisit("CorrosionDosing");

}, []);


   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);


  


  const DEFAULT_VALVES = {
  FCV_3101: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CorrosionDosing_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3101: { ...DEFAULT_VALVES.FCV_FCV_3101, ...parsed.FCV_3101 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CorrosionDosing_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };






// ================= WATER RATIO FOR MIXING =================
const [H2O_3101, setH2O_3101] = useState(() => {
  return Number(localStorage.getItem("H2O_3101")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("H2O_3101", H2O_3101);
}, [H2O_3101]);

const [h2o3101Position, setH2o3101Position] = useState({ x: 314, y: 326 }); // 🔧 adjust freely


// ================= CIH_3101 (FOULING FACTOR - SEAWATER STRAINER) =================
const [CIH_3101, setCIH_3101] = useState(() => {
  return Number(localStorage.getItem("CIH_3101")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("CIH_3101", CIH_3101);
}, [CIH_3101]);

const [cih3101Position, setCih3101Position] = useState({ x: 314, y: 366 }); // 🔧 adjust freely



// ================= VALVE AND PUMPS INITIALIZATION AND STATUS =================
  const isXV3101Open = valves?.XV_3101 === false;
  const isXV3102Open = valves?.XV_3102 === false;
  const isXV3103Open = valves?.XV_3103 === false;
  const isXV3104Open = valves?.XV_3104 === false;

  const isP3101On = pumpData?.["P-3101"]?.running ?? false;
  const isP3102On = pumpData?.["P-3102"]?.running ?? false;

  const isP3103AOn = pumpData?.["P-3103A"]?.running ?? false;
  const isP3103BOn = pumpData?.["P-3103B"]?.running ?? false;

    const FIC_3101 = isXV3101Open ? 100 * CIH_3101/100 : 0;
    const FIC_3102 = isXV3102Open ? 100 * H2O_3101/100 : 0;
    const FIC_3103 = isXV3103Open ? 50 : 0;

    const PT_3101 = isP3101On ? 0.1 : 0.03;





    
  // ================= CORROSION INHIBITOR MIXING PUMPS =================

const runningPumps3101 = [isP3101On].filter(Boolean).length;


    
  // ================= CORROSION INHIBITOR TRANSFER PUMPS =================

const runningPumps3102 = [isP3102On].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow3101 = 0;
const suctionPressure3101 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_3101 =  1.3;
const MIN_DISCH_PRESSURE_3101 = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_3102 = MIN_DISCH_PRESSURE_3101;
let targetFIC_3104 = 0;

if (runningPumps3102 > 0) {

  // 🔹 Flow boost
  targetFIC_3104 = 50;

  // 🔹 Pressure rises to design max
  targetPT_3102 = MAX_DISCH_PRESSURE_3101;

}

// ================= STATES =================
const [PT_3102, setPT_3102] = useState(() => {
  return Number(localStorage.getItem("PT_3102")) || 0.03;
});

const [FIC_3104, setFIC_3104] = useState(() => {
  return Number(localStorage.getItem("FIC_3104")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_3102(prev => {
      const next = prev + (targetPT_3102 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_3104(prev => {
      const next = prev + (targetFIC_3104 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_3102, targetFIC_3104]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_3102", PT_3102);
}, [PT_3102]);

useEffect(() => {
  localStorage.setItem("FIC_3104", FIC_3104);
}, [FIC_3104]);




const PT_3103 = isXV3104Open ? 0.4 : 0;




  // ================= MAIN CORROSION INHIBITION INJECTION PUMPS =================
  const runningPumps3103 = [isP3103AOn, isP3103BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow3103 = 0;
const suctionPressure3103 = PT_3103;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_3103 = PT_3103 * 3.5;
const MIN_DISCH_PRESSURE_3103 = 0.03;

// ================= TARGET CALCULATIONS =================
let targetPT_3104 = MIN_DISCH_PRESSURE_3103;
let targetFIC_3105 = 0;

if (runningPumps3103 > 0) {

  // 🔹 Flow boost
  targetFIC_3105 = isXV3104Open ? 50 * (valveData?.FCV_3101?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_3104 = isXV3104Open ? MAX_DISCH_PRESSURE_3103 * (1 - ((10/100) * (valveData?.FCV_3101?.opening || 0)/100)) : 0.03;

}

// ================= STATES =================
const [PT_3104, setPT_3104] = useState(() => {
  return Number(localStorage.getItem("PT_3104")) || 0.03;
});

const [FIC_3105, setFIC_3105] = useState(() => {
  return Number(localStorage.getItem("FIC_3105")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_3104(prev => {
      const next = prev + (targetPT_3104 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_3105(prev => {
      const next = prev + (targetFIC_3105 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_3104, targetFIC_3105]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_3104", PT_3104);
}, [PT_3104]);

useEffect(() => {
  localStorage.setItem("FIC_3105", FIC_3105);
}, [FIC_3105]);

// ================= LOAD SHARING (OPTIONAL DISPLAY) =================
const loadShare2951 =
  runningPumps3103 > 0 ? (100 / runningPumps3103).toFixed(0) : 0;

// Example (if you want to display per pump later):
const pumpAFlow =
  isP3103AOn && runningPumps3103 > 0
    ? FIC_3105 / runningPumps3103
    : 0;

const pumpBFlow =
  isP3103BOn && runningPumps3103 > 0
    ? FIC_3105 / runningPumps3103
    : 0;







    // ================= CORROSION INHIBITION CONCENTRATION TRAMSMITTER OUTPUT =================
// ================= INPUTS =================
const CI_flow = Number(FIC_3101 || 0);
const H2O_flow = Number(FIC_3102 || 0);


// TRUE when blending is active
const isBlending = isXV3101Open || isXV3102Open;

// ================= RAW PPM =================
const rawPPM = CI_flow * 10000;

// ================= DILUTION MODEL =================
let dilutionFactor = 1;

if (H2O_flow > 0) {
  const ratio = CI_flow / (CI_flow + H2O_flow);
  const exponent = 3.5;
  dilutionFactor = Math.pow(ratio, exponent);
}

const calculatedICT = rawPPM * dilutionFactor;

// ================= HOLD STATE (KEY ADDITION) =================
const [ICT_3101, setICT_3101] = useState(0);

// store last valid value before shutdown
const [lastICT, setLastICT] = useState(0);

// ================= DCS BEHAVIOR =================
useEffect(() => {

  // IF BLENDING ACTIVE → UPDATE NORMAL
  if (isBlending) {

    const interval = setInterval(() => {

      setICT_3101(prev => {
        const next = prev + (calculatedICT - prev) * 0.15;
        const val = Number(next.toFixed(2));

        // keep last known good value updated
        setLastICT(val);

        return val;
      });

    }, 500);

    return () => clearInterval(interval);
  }

  // IF BLENDING STOPPED → HOLD LAST VALUE
  else {
    setICT_3101(lastICT);
  }

}, [isBlending, calculatedICT, lastICT]);










// ================= INPUTS =================
const ICT_3101_value = Number(ICT_3101 || 0);

const FIC_3103_value = Number(FIC_3103 || 0);

// ================= STATE (TRANSFER TANK MEMORY) =================
const [ICT_3102, setICT_3102] = useState(0);
const [frozenICT, setFrozenICT] = useState(0);
const [prevPumpState, setPrevPumpState] = useState(false);

// ================= LOGIC =================
useEffect(() => {

  // 🔵 DETECT PUMP RISING EDGE (OFF → ON)
  const pumpJustTurnedOn = isP3102On && !prevPumpState;

  // 🔴 WHEN PUMP TURNS ON → CAPTURE ICT_3101
  if (pumpJustTurnedOn) {
    setFrozenICT(ICT_3101_value);
  }

  // 🟢 ALWAYS UPDATE PREVIOUS STATE
  setPrevPumpState(isP3102On);

  // ================= DILUTION FACTOR =================
  let dilutedValue = frozenICT;

  if (isXV3103Open && FIC_3103_value > 0) {
    // mild dilution effect
    const dilutionStrength = Math.min(FIC_3103_value / 100, 0.3);

    dilutedValue = frozenICT * (1 - dilutionStrength);
  }

  // ================= UPDATE OUTPUT =================
  setICT_3102(dilutedValue);

}, [
  ICT_3101_value,
  isP3102On,
  isXV3103Open,
  FIC_3103_value,
  frozenICT,
  prevPumpState
]);













useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3105 === FIC_3105 &&
    current.PT_3104 === PT_3104 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3105, PT_3104, 
    }
  });

}, [FIC_3105, PT_3104, ]);









  return (
    <div className="CorrosionDosing-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "252px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 290px"
      }}>
        CORROSION INHIBITION
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3101 */}
      <Valve
        className="XV-3101"
        tag="XV_3101"
        x={220}
        y={122}
        isClosed={valves.XV_3101}
        toggle={toggleValve}
      />

      {/* XV-3102 */}
      <Valve
        className="XV-3102"
        tag="XV_3102"
        x={421}
        y={122}
        isClosed={valves.XV_3102}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3103 */}
      <Valve
        className="XV-3103"
        tag="XV_3103"
        x={849}
        y={116}
        isClosed={valves.XV_3103}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3104 */}
      <Valve
        className="XV-3104"
        tag="XV_3104"
        x={1199}
        y={396}
        isClosed={valves.XV_3104}
        toggle={toggleValve}
        r={90}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3101 */}
        <div
            style={{ position: "absolute", left: 350, top: 599}}
            onMouseEnter={() => setHoveredValve("FCV_3101")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3101")}
          >

            {hoveredValve === "FCV_3101" && (
              <div style={tagStyle}>
                FCV_3101
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3101">
                    
          <defs>
            <linearGradient id="metal_3101">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3101)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3101)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


      
        {/* ================= IMPELLER (INSIDE TANK) ================= */}
      <svg width="500" height="400" style={{ position: "absolute", left: 305, top: 200 }}>

        <MixingTankImpeller
          x={176}
          y={150}
          size={80}
          bladeCount={6}
          speed={3}
          isP3101On={isP3101On}
        />

      </svg>

      <div
          style={{
            position: "absolute",
            left: 213,   // 🔧 adjust position
            top: 288,    // 🔧 adjust position
            color: isP3101On ? "lime" : "red",
            fontWeight: "bold",
            fontSize: "14px",
            background: "rgba(0,0,0,0.6)",
            padding: "2px 4px",
            borderRadius: "4px"
          }}
        >
          {isP3101On ? "MIXING ONGOING" : "MIXING STOPPED"}
        </div>



          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_3101?.opening || 0)}
        x={373}
        y={648}
      />





          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
          tag="FIC-3101"
          value={[FIC_3101]}
          x={129}
          y={159}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF EPICOOL 2000 WATER-BASED CORROSION INHIBITOR INTO THE CORROSION INHIBITION MIXING TANK"
        />
      <Transmitter
          tag="FIC-3102"
          value={[FIC_3102]}
          x={334}
          y={111}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION MIXING TANK "
        />
      <Transmitter
          tag="FIC-3103"
          value={[FIC_3103]}
          x={773}
          y={161}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION TRANSFER TANK FOR FURTHER DILUTION"
        />

        <Transmitter
          tag="PT-3101"
          value={PT_3101}
          x={465}
          y={440}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED WATER-BASED CORROSION INHIBITION SOLUTION AT THE DISCHARGE OF MIXING TANK TO TRANSFER PUMP"
        />
        <Transmitter
          tag="PT-3102"
          value={PT_3102}
          x={727}
          y={408}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED WATER-BASED CORROSION INHIBITION SOLUTION AT THE DISCHARGE OF MIXING TANK TO TRANSFER PUMP"
        />

        <Transmitter
          tag="FIC-3104"
          value={[FIC_3104]}
          x={727}
          y={461}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION TRANSFER TANK FOR FURTHER DILUTION"
        />      
        <Transmitter
          tag="FIC-3105"
          value={[FIC_3105]}
          x={474}
          y={595}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION TO CORROSION INHIBITION HEADER"
        />

        <Transmitter
          tag="PT-3104"
          value={PT_3104}
          x={659}
          y={595}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION TO CORROSION INHIBITION HEADER"
        />      
        <Transmitter
          tag="PT-3103"
          value={PT_3103}
          x={1124}
          y={502}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION FROM TRANSFER TANK TO CORROSION INHIBITION INJECTION PUMP"
        />      















      <Transmitter
          tag="H2O-3101"
          value={[H2O_3101]}
          x={270}
          y={312}
          unit="%"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="PERCENTAGE OF WATER USED FOR BLENDING WITH WATERBASED CORROSION INHIBITOR"
        />
      <Transmitter
          tag="CIH-3101"
          value={[CIH_3101]}
          x={270}
          y={352}
          unit="%"
          max={30}
          HH={25}
          H={20}
          L={10}
          LL={5}
          c="lime"
          description="PERCENTAGE OF WATER-BASED CORROSION INHIBITOR USED FOR BLENDING WITH WATER IN MIXING TANK"
        />

      <Transmitter
          tag="ICT-3101"
          value={[ICT_3101]}
          x={569}
          y={339}
          unit="ppm"
          max={50}
          HH={45}
          H={40}
          L={8}
          LL={5}
          c="lime"
          description="Real-time monitoring of parts-per-million (ppm) levels to ensure the mixing ratio stays within effective ranges (typically 5 - 50 ppm for continuous dosing) in Mixing Tank"
        />
      <Transmitter
          tag="ICT-3102"
          value={[ICT_3102]}
          x={1042}
          y={339}
          unit="ppm"
          max={50}
          HH={45}
          H={40}
          L={8}
          LL={5}
          c="lime"
          description="Real-time monitoring of parts-per-million (ppm) levels to ensure the mixing ratio stays within effective ranges (typically 5 - 50 ppm for continuous dosing) in Transfer Tank"
        />























                <div
                  className="h2o3101-input-group"
                  style={{
                    position: "absolute",
                    left: h2o3101Position.x,
                    top: h2o3101Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="h2o3101-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "transparent",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={H2O_3101}
                    onChange={(e) => setH2O_3101(Number(e.target.value) || 0)}
                  />
                </div>
                
                
                <div
                  className="cih3101-input-group"
                  style={{
                    position: "absolute",
                    left: cih3101Position.x,
                    top: cih3101Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="cih3101-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "transparent",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={CIH_3101}
                    onChange={(e) => setCIH_3101(Number(e.target.value) || 0)}
                  />
                </div>





                
      <Pump
        tag="P-3101"
        x={462}
        y={122}
        rpm={1800}
        bladeCount={pumpData?.["P-3101"]?.bladeCount || 0}
        size={pumpData?.["P-3101"]?.size || 40}
        onClick={openPumpPanel}
      />
          
                
      <Pump
        tag="P-3102"
        x={633}
        y={446}
        rpm={1800}
        bladeCount={pumpData?.["P-3102"]?.bladeCount || 6}
        size={pumpData?.["P-3102"]?.size || 35}
        onClick={openPumpPanel}
      />

      <Pump
        tag="P-3103A"
        x={951}
        y={530}
        rpm={1800}
        bladeCount={pumpData?.["P-3103A"]?.bladeCount || 6}
        size={pumpData?.["P-3103A"]?.size || 35}
        onClick={openPumpPanel}
      />
      <Pump
        tag="P-3103B"
        x={951}
        y={654}
        rpm={1800}
        bladeCount={pumpData?.["P-3103B"]?.bladeCount || 6}
        size={pumpData?.["P-3103B"]?.size || 35}
        onClick={openPumpPanel}
      />

    
          
      <LevelTransmitterIndicator
      tag="LT_3101"
      totalLevel={100000}
      inflows={[FIC_3101 + FIC_3102]}
      outflows={[FIC_3104]}
      responseFactor={0.05}
      columnX={360}
      columnY={230}
      columnWidth={199}
      columnHeight={166}
      textX={569}
      textY={218}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
      service="inhibitor"
    />
      <LevelTransmitterIndicator
      tag="LT_3102"
      totalLevel={150000}
      inflows={[FIC_3104 + FIC_3103]}
      outflows={[FIC_3105]}
      responseFactor={0.05}
      columnX={847}
      columnY={230}
      columnWidth={183}
      columnHeight={166}
      textX={1039}
      textY={218}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
      service="inhibitor"
    />
           



    </div>
  );
}


export default CorrosionDosing;